import * as React from "react";
import { Card, Tabs } from "antd";
import NewUsersReport from "../../components/public-users/dashboard/newUsers";
import DeviceReport from "../../components/public-users/dashboard/deviceReport";
import TotalUsersReport from '../../components/public-users/dashboard/totalUsers';
import __i18n from "../../intl/__i18n";
const {TabPane} = Tabs;


//TODO:  Use webpack config to imprt css to set class names

function DashboardPage() {
  
  return(
    <Tabs type="card">
      <TabPane tab={__i18n("Statistic Information")} key="statistic_information">
        <TotalUsersReport/>
      </TabPane>
    
      <TabPane tab={__i18n("New Users")} key="new_users">
        <NewUsersReport/>
      </TabPane>
    
      <TabPane tab={__i18n("New Devices")} key="new_devices">
        <DeviceReport/>
      </TabPane>
    </Tabs>
  )
}

export default DashboardPage;

